import React from "react";
import Grid from "canvas-core-react/lib/Grid";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import Margin from "canvas-core-react/lib/Margin";
import TextBody from "canvas-core-react/lib/TextBody";
import {TitleCustom} from "../../../components/TitleCustom/TitleCustom";
import ImgBannerMobile from "../../../assets/images/two-persons.jpg";

const Mobile = () => {
    return (
        <Grid className={"banner-mobile"}>
            <Row>
                <Column xs={4} sm={8} md={8} mdOffset={2} lg={8} lgOffset={2}>
                    <Row>
                        <Column>
                            <Margin
                                xs={[0, 0, 24, 0]}
                                sm={[0, 0, 24, 0]}
                                md={[0, 0, 24, 0]}
                                lg={[0, 0, 24, 0]}
                            >
                                <TitleCustom text="Necesitamos algunos datos tuyos"/>
                            </Margin>
                        </Column>
                    </Row>
                    <Row>
                        <Column>
                            <Margin
                                xs={[0, 0, 24, 0]}
                                sm={[0, 0, 24, 0]}
                                md={[0, 0, 24, 0]}
                                lg={[0, 0, 24, 0]}
                            >
                                <TextBody
                                    component="p"
                                    type="2"
                                    className={"align-items--center"}
                                >
                                    Ahora puedes continuar tu validación como cliente siguiendo
                                    estos sencillos pasos.
                                </TextBody>
                            </Margin>
                        </Column>
                    </Row>
                    <Row>
                        <Column xs={4} sm={8} md={8} mdOffset={2} lg={8} lgOffset={2}>
                            <Margin
                                xs={[0, 0, 36, 0]}
                                sm={[0, 0, 36, 0]}
                                md={[0, 0, 36, 0]}
                                lg={[0, 0, 36, 0]}
                            >
                                <img
                                    src={ImgBannerMobile}
                                    alt="welcome"
                                    className={"img-welcome"}
                                />
                            </Margin>
                        </Column>
                    </Row>
                </Column>
            </Row>
        </Grid>
    );
};

export default Mobile;
